import { motion } from 'framer-motion'
import React, { useState } from 'react'
import { useIsMobile } from '../../hooks/useIsMobile'
import DynamicLink from '../atoms/DynamicLink'
import PlusIcon from '../icons/PlusIcon'
import slugify from 'slugify'
import MinusIcon from '../icons/MinusIcon'

const FooterUnsereStandorte = ({ heading, links }) => {
  const isMobile = useIsMobile()
  const [isStandorteOpen, setStandorteOpen] = useState(false)

  return (
    <div className="flex-1 text-black md:mt-5.5 md:mb-14 xl:mb-0">
      <div className="border-t md:mb-3 md:border-0 border-gray-4">
        <DynamicLink
          link={heading}
          className="underline text-[15px] font-bold leading-normal hidden md:flex transition-colors hover:text-red-as"
        />
        <button
          type="button"
          className="text-[15px] font-bold md:hidden py-4 flex items-center justify-between w-full"
          onClick={() => setStandorteOpen(!isStandorteOpen)}
        >
          <span>{heading.text}</span>
          {isStandorteOpen ? <MinusIcon /> : <PlusIcon />}
        </button>
      </div>
      <motion.ul
        className="space-y-1.5 text-[15px] border-b md:border-0 border-gray-4 overflow-hidden pl-2 md:pl-0 md:columns-2 xl:columns-1"
        animate={{ height: isStandorteOpen || !isMobile ? 'auto' : 0 }}
        transition={{ type: 'ease' }}
      >
        {links.map(({ linkItem: link }, index) => (
          <li
            key={link.text}
            className={index === links.length - 1 ? 'pb-4' : ''}
          >
            <DynamicLink
              link={link}
              append={`?city=${slugify(link.text).toLowerCase()}`}
              className="underline transition-colors hover:text-red-as"
            />
          </li>
        ))}
      </motion.ul>
    </div>
  )
}

export default FooterUnsereStandorte
